var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNuxtjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5377204,0,0,2.5377204,-12.870824,-44.131613)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00c492",
    d: "m12.738 38.729a.937.937 0 0 1-.05-.102 1.314 1.314 0 0 1-.089-.741H6.637l8.86-15.592 2.91 5.113.843-1.492-2.536-4.467A1.55 1.55 0 0 0 15.476 20.63a1.378 1.378 0 0 0-1.201.827l-8.976 15.782a1.587 1.587 0 0 0-.079 1.49 1.381 1.381 0 0 0 1.314.633h7.518a1.378 1.378 0 0 1-1.314-.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008776",
    d: "M30.023 37.239 22.647 24.245a1.554 1.554 0 0 0-1.243-.828 1.374 1.374 0 0 0-1.201.825l-.954 1.671.849 1.492 1.313-2.325 7.297 12.804h-2.775a1.243 1.243 0 0 1-.058.631.8.8 0 0 1-.058.129l-.024.047a1.588 1.588 0 0 1-1.337.67h4.341a1.586 1.586 0 0 0 1.337-.67 1.378 1.378 0 0 0-.113-1.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d4a5d",
    d: "m25.795 38.692.024-.047a.8.8 0 0 0 .058-.129 1.243 1.243 0 0 0 .058-.631 1.92 1.92 0 0 0-.242-.646l-5.589-9.833-.854-1.492-.848 1.492-5.586 9.833a1.99 1.99 0 0 0-.215.646 1.314 1.314 0 0 0 .081.741.928.928 0 0 0 .05.102 1.381 1.381 0 0 0 1.314.633H24.45a1.592 1.592 0 0 0 1.345-.67zm-6.545-9.793 5.108 8.987H14.144z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxtjs);
export default __webpack_public_path__ + "static/media/nuxtjs.96e0df8a4c2d758cc4aeb207b8c0b390.svg";
export { ForwardRef as ReactComponent };